import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import certificationAuditView from '../certification-audit/views/certification-audit-view'
import certificationDetail from './views/components/certification-detail'

export default [
  {
    path: RoutePathConstants.CERTIFICATION_AUDIT_VIEW,
    name: 'certificationAuditView',
    component: certificationAuditView
  },
  {
    path: RoutePathConstants.CERTIFICATION_DETAIL,
    name: 'certificationDetail',
    component: certificationDetail
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/certification-audit/routers.js